<script>
    import TheSlider from "@main/packages/TheSlider";
    import TheGuaranteeListItem from "./components/TheGuaranteeListItem";

    export default {
        name: "TheGuaranteeList",
        components: {
            TheSlider,
            TheGuaranteeListItem,
        },
        props: {
            breakpoints: Object,
            textForYear: String,
            textForBrand: String,
            isScrollbar: {
                default: false,
                type: Boolean,
            },
            isBullets: {
                default: true,
                type: Boolean,
            },
            isVisibleTitle: {
                type: Boolean,
                default: true,
            },
            customText: {
                type: Object,
                default: () => ({}),
            },
        },
        data() {
            return {
                options: this.breakpoints,
                list: [
                    {
                        image: "return.gif",
                        title: "Возврат без проблем",
                        text: "В&nbsp;течение 14&nbsp;дней после покупки, если что-то не&nbsp;понравилось",
                    },
                    {
                        image: "guarantee.gif",
                        title: `Гарантия ${this.textForYear}`,
                        text:
                            this.customText.guarantee ||
                            "На&nbsp;все продукты, кроме расходных материалов и&nbsp;дополнительных аксессуаров",
                    },
                    {
                        image: "identity.gif",
                        title: "100% подлинность",
                        text:
                            this.customText.identity ||
                            `Единственный официальный интернет-магазин ${this.textForBrand} в России`,
                    },
                    {
                        image: "support.gif",
                        title: "Поддержка 7 дней в неделю",
                        text: "Задайте вопрос по&nbsp;телефону, в&nbsp;мессенджерах, чате на&nbsp;сайте или по&nbsp;почте",
                    },
                ],
            };
        },
    };
</script>

<template>
    <div class="guarantee-list">
        <h2 class="guarantee-list__title" v-if="isVisibleTitle">Уверенность в покупке</h2>
        <the-slider
            name-slider="guarantee"
            :is-scrollbar="isScrollbar"
            :options="options"
            :list="list"
            :is-arrow="false"
            :is-bullets="isBullets"
            :bullets-options="{ dynamicBullets: true }"
        >
            <the-guarantee-list-item
                slot="swiper-slide"
                class="swiper-slide"
                v-for="(item, i) in list"
                :key="i"
                :guarantee="item"
            ></the-guarantee-list-item>
        </the-slider>
    </div>
</template>

<style lang="scss">
    .guarantee-list__title {
        margin-bottom: 40px;
        font-family: var(--typography-heading-font);
        font-size: 20px;
        font-weight: var(--typography-heading-weight);
        line-height: 24px;
        letter-spacing: 0.005em;
        @include bp($bp-desktop-sm) {
            font-size: 36px;
            line-height: 40px;
            text-align: center;
        }
    }
</style>
